<template>
  <!-- prettier-ignore -->
  <div :class="classes">
    <div class="card__title">
      <slot name="title" />
      <div
        v-if="$slots.subtitle"
        class="card__subtitle"
      >
        <slot name="subtitle" />
      </div>

    </div>
    <div class="card-content"><slot name="default" /></div>
  </div>
</template>

<script>
export default {
  name: 'OvpDapCard',

  props: {
    invalid: {
      type: Boolean,
      default: false,
    },

    valid: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    classes() {
      return {
        card: true,
        'card--invalid': this.invalid,
        'card--valid': this.valid,
      }
    },
  },
}
</script>

<style name="mobile" scoped>
.card {
  background-color: var(--c-white);
  padding: 15px;
  border: 1px solid transparent;
  transition: border-color 0.3s ease-in-out;

  &__title {
    font-size: 20px;
    line-height: 35px;
    font-weight: bold;
    color: var(--c-black);
    margin-bottom: 16px;

    transition: color 0.3s ease-in-out;
  }

  &__subtitle {
    font-size: 14px;
    line-height: 20px;
    font-weight: normal;
  }

  &-content {
    flex: 1 1 auto;
    max-width: 460px;
    color: var(--c-black);
  }

  &--invalid {
    border-color: var(--c-error);

    .card__title {
      color: var(--c-error);
    }
  }

  &--valid {
    border-color: var(--c-sanitas-green);

    .card__title {
      color: var(--c-sanitas-green);
    }
  }
}
</style>

<style name="desktop" scoped>
@media (--md) {
  .card {
    display: flex;
    flex-direction: row;
    padding: 20px;

    &__title {
      flex: 0 0 50%;
    }
  }
}
</style>
